import { IconRefresh } from "@tabler/icons";
import { useTheme } from "styled-components";

import { useGetOrdersQuery } from "@sso/apis/order/hooks";
import { TableHeader } from "@sso/components/TableHeader";
import { TableLayoutWrapper } from "@sso/components/TableLayoutWrapper";
import { TablePagination } from "@sso/components/TablePagination";
import { TableProvider, TableProviderState } from "@sso/context/tableContext";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectOrderPagination } from "@sso/store/slices/order";
import { OrderSummaryRowKeys } from "@sso/types";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";

import { OrdersTable } from "./orderTable";
import { orderTableColumns } from "./orderTableColumns";

const dataKeys = [
  OrderSummaryRowKeys.SOFTWARE_NAME,
  OrderSummaryRowKeys.USER,
  OrderSummaryRowKeys.ORGANISATION,
  OrderSummaryRowKeys.CREATED_DATE,
  OrderSummaryRowKeys.STATUS_LABEL,
  OrderSummaryRowKeys.PAYMENT_MODE,
  OrderSummaryRowKeys.VALUE,
];

const Orders = () => {
  const theme = useTheme();

  const orderPagination = useAppSelector(selectOrderPagination);
  const { data, isFetching, error, refetch } = useGetOrdersQuery();

  const tableContextInstance: TableProviderState = { ...orderPagination, columns: orderTableColumns };

  const TableActions = (
    <Flex>
      <IconButton title="Refresh" onClick={refetch}>
        <IconRefresh />
      </IconButton>
    </Flex>
  );

  return (
    <>
      {isFetching && <CircleLoading color={theme.colors.secondary.dark} size={8} blurBackground />}
      <TableProvider tableInstance={tableContextInstance}>
        <TableHeader title="Orders" TableActions={TableActions} />
        <TableLayoutWrapper error={error} data={data}>
          {data && <OrdersTable data={data.resources} orderTableColumns={orderTableColumns} dataKeys={dataKeys} />}
        </TableLayoutWrapper>
        <TablePagination totalPages={data?.totalPages} />
      </TableProvider>
    </>
  );
};

export default Orders;
